module.exports = "/packs/media/images/budget3-f3e6f716955c371b1773bf6a4d8d735d.jpg";